"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = require("react");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _LinearProgress = _interopRequireDefault(require("@mui/material/LinearProgress"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "className", "loading", "fetching", "grow", "flexGrow", "showChildren", "transparent", "position", "isolated", "sticky", "fetchingOffset"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      position: function position(_ref) {
        var _position = _ref.position;
        return _position;
      },
      width: '100%',
      height: function height(_ref2) {
        var grow = _ref2.grow;
        return grow ? '100%' : null;
      }
    },
    backdrop: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: function background(_ref3) {
        var transparent = _ref3.transparent;
        return transparent ? 'transparent' : theme.palette.action.disabledBackground;
      },
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 5 // great then sticky table cell zIndex
    },
    sticky: {
      position: 'sticky',
      top: 0,
      bottom: 0,
      width: '100%',
      height: '100%'
    },
    progress: {
      position: 'absolute',
      zIndex: 3,
      left: 0,
      right: 0,
      top: 0
    },
    fetchingOffset: {
      top: -3
    }
  };
});
var defaultParentContext = {
  loading: false,
  fetching: false
};
var ViewContext = /*#__PURE__*/(0, _react.createContext)(defaultParentContext);
var dataCy = exports.dataCy = 'View';
var View = function View(props) {
  var children = props.children,
    className = props.className,
    loadingProp = props.loading,
    fetching = props.fetching,
    _props$grow = props.grow,
    grow = _props$grow === void 0 ? true : _props$grow,
    flexGrow = props.flexGrow,
    _props$showChildren = props.showChildren,
    showChildren = _props$showChildren === void 0 ? true : _props$showChildren,
    transparent = props.transparent,
    _props$position = props.position,
    position = _props$position === void 0 ? 'relative' : _props$position,
    _props$isolated = props.isolated,
    isolated = _props$isolated === void 0 ? false : _props$isolated,
    sticky = props.sticky,
    fetchingOffset = props.fetchingOffset,
    other = _objectWithoutProperties(props, _excluded);
  var parent = (0, _react.useContext)(ViewContext);
  if (isolated) {
    parent = _objectSpread({}, defaultParentContext);
  }
  var loading = !parent.loading && loadingProp;
  if (typeof transparent !== 'boolean') {
    if (fetching && !loading) {
      transparent = true;
    }
  }
  var classes = useStyles({
    grow: grow,
    flexGrow: flexGrow,
    transparent: transparent,
    position: position
  });
  var dataStatus = (0, _react.useMemo)(function () {
    if (!loading && fetching) {
      return "Fetching";
    }
    if (loading) {
      return "Loading";
    }
    return "Loaded";
  }, [loading, fetching]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ViewContext.Provider, {
    value: {
      loading: parent.loading || loadingProp
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
      className: (0, _clsx3["default"])(classes.root, className, _defineProperty({}, classes.sticky, sticky)),
      "data-cy": dataCy,
      "data-cy-state": dataStatus
    }, other), {}, {
      children: [loading && !showChildren ? null : children, loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: classes.backdrop,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress["default"], {
          "data-cy-role": 'circleProgress'
        })
      }) : fetching && (transparent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinearProgress["default"], {
        "data-cy-role": 'linearProgress',
        color: 'primary',
        className: (0, _clsx3["default"])(classes.progress, _defineProperty({}, classes.fetchingOffset, fetchingOffset))
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: classes.backdrop,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinearProgress["default"], {
          "data-cy-role": 'linearProgress',
          color: 'primary',
          className: classes.progress
        })
      }))]
    }))
  });
};
View.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].func, _propTypes["default"].node]),
  className: _propTypes["default"].string,
  'data-сy': _propTypes["default"].string,
  fetching: _propTypes["default"].bool,
  grow: _propTypes["default"].bool,
  loading: _propTypes["default"].bool,
  position: _propTypes["default"].oneOf(['static', 'relative', 'absolute', 'sticky', 'fixed']),
  showChildren: _propTypes["default"].bool,
  transparent: _propTypes["default"].bool,
  isolated: _propTypes["default"].bool
};
var _default = exports["default"] = View;